'use client'

import { ArticleView } from 'components/ArticleView/ArticleView'

/**
 * @param {any} content Contentful content object
 * @param {string} completePageUrl Full page URL
 * @param {string} pageHost Hostname of the page
 * @param {object | undefined} listingPage Listing page object
 * @returns {ReactElement} Returns a React element
 */
export function ArticleClientShell({
  content,
  siteInfo,
  completePageUrl,
  pageHost,
  listingPage = undefined,
}) {
  return (
    <>
      <ArticleView
        content={content}
        siteInfo={siteInfo}
        completePageUrl={completePageUrl}
        listingPage={listingPage}
        pageHost={pageHost}
      />
    </>
  )
}
